/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthControllerReadiness200ResponseInfoValue
 */
export interface HealthControllerReadiness200ResponseInfoValue {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof HealthControllerReadiness200ResponseInfoValue
     */
    status: string;
}

/**
 * Check if a given object implements the HealthControllerReadiness200ResponseInfoValue interface.
 */
export function instanceOfHealthControllerReadiness200ResponseInfoValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function HealthControllerReadiness200ResponseInfoValueFromJSON(json: any): HealthControllerReadiness200ResponseInfoValue {
    return HealthControllerReadiness200ResponseInfoValueFromJSONTyped(json, false);
}

export function HealthControllerReadiness200ResponseInfoValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthControllerReadiness200ResponseInfoValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'status': json['status'],
    };
}

export function HealthControllerReadiness200ResponseInfoValueToJSON(value?: HealthControllerReadiness200ResponseInfoValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'status': value.status,
    };
}

